import React, { PureComponent } from "react";
 
import { BrowserRouter as Router} from "react-router-dom";
import {getRouter} from '../router';
import GlobalHeader from 'components/GlobalHeader'
import GlobalFooter from 'components/GlobalFooter'
import "./index.scss";

var nav = [
    {
        name: "教育培训",
        url: "/education/educationTraining",
        // active: 1
    },
    {
        name: "培训申请",
        url: "/education/trainingApplication",
        // active: 1
    },
    {
        name: "结果查询",
        url: "/education/result"
    },
    {
        name: "培训机构",
        url: "/education/educationTrainingOrganization"
    },
    {
        name: "培训政策",
        url: "/education/deucationTrainingInfo"
    },
    {
        name: "培训资讯",
        url: "/education/deucationTrainingPolicy"
    }
]


export default class Index extends PureComponent {
  render() {
    return (
        <div>
            <GlobalHeader nav={nav}  history={this.props.history}/>
             {getRouter()}
            <GlobalFooter />
        </div>
    );
  }
}
